import { createUseMutationHook } from './createUseMutationHook';

export const useCancelPersonTrip = createUseMutationHook(
    'person_trip_cancel',
    tripId => [
        ['trip_detail', tripId],
        ['person_trip_detail', tripId],
    ],
);
